// Core packages
import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from '@angular/forms';
import { Router } from "@angular/router";

// Third party packages
import { MatDialog } from "@angular/material";
import { Sort } from '@angular/material/sort';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { TranslateService } from "@ngx-translate/core";
import { Workbook } from 'exceljs';
import * as FileSaver from "file-saver";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";

// Core packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { RolesService } from 'src/app/modules/roles/roles.service';
import { SummaryDocsService } from 'src/app/modules/summary-docs/summary-docs.service';
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from 'src/app/shared/services/helper.service';
import { ThemeService } from 'src/app/shared/services/theme.service';

import moment from 'moment';
import { SuppliersService } from 'src/app/modules/suppliers/suppliers.service';
import { UsersService } from 'src/app/modules/users/users.service';
import { Supplier } from 'src/app/shared/models/supplier/supplier.model';
import { IUser } from 'src/app/shared/models/user/user.interface';
import { DateTimeFormatPipe } from "src/app/shared/pipes/date-format.pipe";
import DocumentTypeStructure from "../../../properties/documentTypes";

@Component({
  selector: 'app-next-insertions-list',
  templateUrl: './next-insertions-list.page.html',
  styleUrls: ['./next-insertions-list.page.scss']
})
export class NextInsertionsDocsListComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];
  loggedUser: IUser;
  loggedUserPermissions: string[];
  loggedUserRole: any;
  currentRole: any;
  lang = this.translateService.currentLang || this.translateService.defaultLang;
  loggedUserMaster = false;
  dateTimeFormat: DateTimeFormatPipe;
  activeSection: string; // Active document section
  activeSectionData: any[] = [];
  itemId: string; // Id of active mapping section item
  condoStructure: any;
  documentArchive: any;
  documentArchiveId: string;
  sortedDocuments: any[] = [];
  documentArchiveIsLoading = false;
  public documentTypeStructure: DocumentTypeStructure = new DocumentTypeStructure();

  summaryDocs: any[] = [];
  sortedData = [];
  filterValue = "";
  masters = [];
  selectedUser = "-1";
  selectedMaster = "-1";
  mastersSelected = this.translateService.instant("properties.documents.nextInsertions.none");
  canExport = false;
  showParameters = true;
  areas: any;
  topics: any;
  subTopics: any;
  documents: any[] = [];
  selectedArea: string;
  selectedTopic: any;
  selectedSubTopics: any[] = [];
  selectedDocuments: any[] = [];
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  supplier: Supplier;
  previousSupplierId: string;
  selectedCompany: any;
  selectAll: any;

  // Dati aggiuntivi elenco/nuovo elemento
  suppliersName: any[] = [];
  yearsOfStorage: any[] = [];
  conductorName: any[] = [];
  nameInterventionArchiving: any[] = [];

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private router: Router,
    private toastrService: ToastrService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private authService: AuthService,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private summaryDocsService: SummaryDocsService,
    private rolesService: RolesService,
    private suppliersService: SuppliersService,
    private helperService: HelperService,
    private userService: UsersService,
    private apiService: ApiService, // DO NOT MOVE since it's used for 'autocomplete' field type
  ) { }


  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    // Set page title
    this.themeService.setPageTitle(
      this.translateService.instant("properties.documentsPage.pageTitle")
    );

    // Get current lang
    this.lang =
      this.cookieService.get("lang") || this.configService.defaultLang;

    // Get logged user data
    this.subscriptions.push(
      this.authService.loggedUser$.subscribe(res => (this.loggedUser = res))
    );
    this.subscriptions.push(
      this.authService.loggedUserPermissions$.subscribe(
        res => (this.loggedUserPermissions = res)
      )
    );

    // Get logged user's role data
    this.currentRole = this.authService.loggedUserRequestedRoleType$.getValue();
    if (this.currentRole !== "admin" && this.currentRole !== "operator") {
      this.toastrService.error(this.translateService.instant("common.errors.not_authorized"));
      this.router.navigate([this.lang, 'app']);
    }

    this.subscriptions.push(
      this.summaryDocsService
        .getSummaryDocsMasters()
        .subscribe(res => {
          if (res.status) {
            this.masters = res.data.items;
          }
        })
    );

    this.initSupplierForm();
  }

  /**
   * Handle component destroy
   *
   * @since 1.0.0
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * init field form
   *
   * @since 1.0.0
   */
  initSupplierForm(): void {
    this.fields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: 'col-12 col-sm-8 col-md-6',
            type: 'datepicker',
            key: 'startDate',
            templateOptions: {
              label: this.translateService.instant('common.words.from'),
              placeholder: this.translateService.instant('properties.documents.nextInsertions.searchDate'),
              // max: this.model && this.model.endDate ? this.model.endDate : undefined,
            },
            // expressionProperties: {
            //   "templateOptions.max": (model: any) => {
            //     return model.endDate;
            //   },
            // }
          },
          {
            className: 'col-12 col-sm-8 col-md-6',
            type: 'datepicker',
            key: 'endDate',
            templateOptions: {
              label: this.translateService.instant('common.words.to'),
              placeholder: this.translateService.instant('properties.documents.nextInsertions.searchDate'),
              // min: this.model && this.model.startDate ? this.model.startDate : undefined,
            },
            // expressionProperties: {
            //   "templateOptions.min": "model.startDate",
            // }
          },
        ]
      }
    ];
  }

  /**
   * Get current property data
   *
   * @since 1.0.0
   */
  getSupplierData(supplierId: string): void {
    if (supplierId === this.previousSupplierId) {
      return;
    }

    // Get requested supplier data
    this.previousSupplierId = supplierId;

    if (!supplierId) {
      // Reset data
      this.supplier = undefined;
      return;
    }

    this.subscriptions.push(
      this.suppliersService.getV2(supplierId).subscribe(
        res => {
          if (res.status) {
            this.supplier = new Supplier();
            this.supplier.setData(res.data);
            return;
          }
        },
        err => {
          // if we came here supplier do not exists
          this.helperService.handleError(err);
        }
      )
    );
  }

  /**
   * Submit filter data and get results
   *
   * @since 1.0.0
   */
  applyFilter(): void {
    let master = "";
    if (this.selectedMaster !== "-1") {
      master = this.selectedMaster;
    } else {
      master = "-1";
    }

    // Prepare filtering data
    const filterData = {
      master: master,
      startDate: this.model && this.model.startDate ? moment(this.model.startDate).local(true).toISOString() : undefined,
      endDate: this.model && this.model.endDate ? moment(this.model.endDate).local(true).toISOString() : undefined,
    };


    this.canExport = false;
    this.documentArchiveIsLoading = true;
    this.summaryDocs = [];
    this.subscriptions.push(
      this.summaryDocsService
        .getNextInsertionsGeneral(this.filterValue, filterData)
        .subscribe(res => {
          if (res.status) {
            if (res.data.items
              && Array.isArray(res.data.items)) {
              res.data.items.forEach((item: any) => {
                this.summaryDocs.push({
                  from: item.from,
                  to: item.to,
                  company: item.company,
                  property: item.property,
                  insertTotalDoc: item.insertTotalDoc,
                  insertTotalPdf: item.insertTotalPdf,
                  deletedTotalDoc: item.deletedTotalDoc,
                  type: item.type
                });
              });
            }
            this.sortedData = this.summaryDocs.slice();
            if (Array.isArray(this.sortedData) && this.sortedData.length) {
              this.canExport = true;
              this.sortedData.sort((a, b) => {
                const propertyA = a.property.toString();
                const propertyB = b.property.toString();
                const typeA = a.type.toString();
                const typeB = b.type.toString();

                let comparison = 0;
                // if (createdByA > createdByB 
                //   && propertyIdA > propertyIdB
                //   && insertDateA > insertDateB) {
                //   comparison = 1;
                // } else if (createdByA > createdByB 
                //   && propertyIdA > propertyIdB
                //   && insertDateA < insertDateB) {
                //   comparison = -1;
                // } else if (createdByA > createdByB 
                //   && propertyIdA < propertyIdB
                //   && insertDateA < insertDateB) {
                //   comparison = -1;
                // } else if (createdByA < createdByB 
                //   && propertyIdA < propertyIdB
                //   && insertDateA < insertDateB) {
                //   comparison = -1;
                // }
                if (
                  propertyA > propertyB
                ) {
                  comparison = 1;
                } else if (
                  propertyA < propertyB
                ) {
                  comparison = -1;
                }
                return comparison;
              });
            }

            this.showParameters = false;
            this.documentArchiveIsLoading = false;
          } else {
            this.documentArchiveIsLoading = false;
            this.toastrService.error(res.message);
          }
        })
    );
  }

  /**
   * Handle documents filtering
   *
   * @since 1.0.0
   */
  filterDocuments(): void {
    const regex = new RegExp(this.filterValue.trim().toLowerCase(), "gi");
    this.documents.forEach((el: any) => {
      if ((el.title && el.title.search(regex) > -1) || el.code.search(regex) > -1) {
        el.visible = true;
      } else {
        el.visible = false;
        el.value = false;
      }
    });
  }

  /**
   * Handle table sort
   *
   * @since 1.0.0
   */
  sortData(sort: Sort): any {
    const data = this.sortedData;
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'company': return this.compare(a.company, b.company, isAsc);
        case 'property': return this.compare(a.property, b.property, isAsc);
        case 'from': return this.compare(a.from, b.from, isAsc);
        case 'to': return this.compare(a.to, b.to, isAsc);
        case 'insertTotalDoc': return this.compare(a.insertTotalDoc, b.insertTotalDoc, isAsc);
        case 'insertTotalPdf': return this.compare(a.insertTotalPdf, b.insertTotalPdf, isAsc);
        case 'deletedTotalDoc': return this.compare(a.deletedTotalDoc, b.deletedTotalDoc, isAsc);
        case 'type': return this.compare(a.type, b.type, isAsc);
        default: return 0;
      }
    });
  }

  /**
   * Utility per table sort
   *
   * @since 1.0.0
   */
  compare(a: number | string, b: number | string, isAsc: boolean): any {
    if (typeof a === "string") {
      a = a.toLowerCase();
    }
    if (typeof b === "string") {
      b = b.toLowerCase();
    }
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  /**
   * Utility: export results to excel
   *
   * @since 1.0.0
   */
  onExportToExcel(): void {
    const defaultColLength = 20;
    // let maxPropertyColLength = 0;
    // let maxTypeColLength = 0;
    // let maxContentColLength = 0;
    // let maxReferenceColLength = 0;
    // let maxDateTimeColLength = 0;

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("Sheet");
    const header = [
      this.translateService.instant('properties.documents.nextInsertions.company'),
      this.translateService.instant('properties.documents.nextInsertions.property'),
      this.translateService.instant('properties.documents.nextInsertions.from'),
      this.translateService.instant('properties.documents.nextInsertions.to'),
      this.translateService.instant('properties.documents.nextInsertions.insertTotalDoc'),
      this.translateService.instant('properties.documents.nextInsertions.insertTotalPdf'),
      this.translateService.instant('properties.documents.nextInsertions.deletedTotalDoc'),
      this.translateService.instant('properties.documents.nextInsertions.type')
    ];
    worksheet.addRow(header);
    worksheet.lastRow.height = 37.45; // Altezza riga 25
    worksheet.lastRow.alignment = {
      horizontal: "center",
      vertical: "middle",
      wrapText: true,
    };
    worksheet.lastRow.font = {
      size: 7,
    };
    const widths = [30, 12, 20, 20, 15, 15, 15, 20];
    widths.forEach((val, index) => {
      worksheet.getColumn(index + 1).width = val;
    });

    worksheet.getRow(1).eachCell({ includeEmpty: true }, (cell) => {
      worksheet.getCell(cell.address).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF87CEEB" },
      };
    });

    // BEGIN - Print settings
    // Set horizontal page orientation
    worksheet.pageSetup = {
      orientation: "landscape",
      paperSize: 9, // A4
      showGridLines: true,
    };

    // Set page header/footer
    worksheet.headerFooter.oddHeader = `&LArchedi&RStampato il ${moment().format(
      "DD/MM/YYYY"
    )}`;
    worksheet.headerFooter.oddFooter = `&L${this.translateService.instant('properties.documents.nextInsertions.footerFileName')}&RPage &P/&N`;
    // END - Print settings

    let rowCount = 1;
    this.sortedData.forEach(el => {

      rowCount++;
      const row = worksheet.addRow([
        el.company,
        el.property,
        el.from ? formatDate(el.from, "dd/MM/yyyy", this.lang) : undefined,
        el.to ? formatDate(el.to, "dd/MM/yyyy", this.lang) : undefined,
        el.insertTotalDoc,
        el.insertTotalPdf,
        el.deletedTotalDoc,
        el.type,
      ]);
      worksheet.lastRow.font = {
        size: 7,
      };

      let maxLine = 1;
      for (let i = 1; i <= widths.length; i++) {
        if (i === 1) {
          worksheet.lastRow.getCell(i).alignment = {
            horizontal: "left",
            indent: 0,
            vertical: "middle",
            wrapText: true,
          };
        } else {
          worksheet.lastRow.getCell(i).alignment = {
            horizontal: "left",
            indent: 1,
            vertical: "middle",
            wrapText: true,
          };
        }

        const cellText = worksheet.lastRow.getCell(i).value;
        let value = -1;
        if (cellText) {
          value =
            Math.ceil(
              worksheet.lastRow.getCell(i).value.toString().length /
                widths[i - 1]
            ) - 1;
          const countLine = (
            worksheet.lastRow
              .getCell(i)
              .value.toString()
              .match(/(?:\r\n|\r|\n)/g) || []
          ).length;
          if (countLine > value) {
            value = countLine;
          }
        }
        if (value > maxLine) {
          maxLine = value;
        }
        worksheet.lastRow.height = 22.45 * maxLine; // 22.45 = altezza riga 15
      }
    });

    // Save to file
    const date = formatDate(new Date(), "yyyyMMddhhmmss", this.lang);
    const fileName = `${this.translateService.instant(
      "properties.documents.nextInsertions.exportFileName"
    )} ${date}.xlsx`;
    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob(
        [data], 
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
      );
      FileSaver.saveAs(blob, fileName);
    });

    this.toastrService.success(this.translateService.instant('properties.documents.nextInsertions.exportedSuccessfully'));
  }
}
